module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('form.billPaymentModal.title') + ' ' + _vm.billingNumber))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "billpayment-top-summary"
  }, [_c('i', {
    staticClass: "fa fa-info-circle fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('form.billPaymentModal.amountDue')) + " " + _vm._s(_vm.additionalData.due_date) + ":")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.reports.bills.invoiceAmount')) + ":")]), _vm._v(" " + _vm._s(new Intl.NumberFormat('no-NO', {
    style: 'currency',
    currency: 'NOK'
  }).format(_vm.additionalData.total))), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('static.reports.bills.paidAmount')) + ":")]), _vm._v(" " + _vm._s(new Intl.NumberFormat('no-NO', {
    style: 'currency',
    currency: 'NOK'
  }).format(_vm.additionalData.paid))), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('static.reports.bills.dueAmount')) + ":")]), _vm._v(" " + _vm._s(new Intl.NumberFormat('no-NO', {
    style: 'currency',
    currency: 'NOK'
  }).format(_vm.additionalData.due)) + "\n            ")])]), _vm._v(" "), _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.billPaymentModal",
      "hasLabel": true
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.complete
    }
  }, [_vm._v(_vm._s(_vm.$t('button.complete').toUpperCase()))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ee6d6cb","hasScoped":false}!./src/app/components/billPayment/billPayment.html
// module id = 3001
// module chunks = 1